<!--
 * @Description: 代课单选
 * @Author: PF
 * @Date: 2023-03-22 10:52:21
 * @LastEditors: PF
 * @LastEditTime: 2024-09-30 09:42:51
-->
<template>
  <div class="tan-chuang">
    <el-dialog class="wp80 hp80" :model-value="openDanTiao" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <span class="header-title">代课</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDanTiao', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-container>
        <el-header class="pl0 pr0">
          <!-- 搜索区域 BEGIN -->
          <el-form class="search-box mb0" :model="dataGrid.parms" @submit.enter.prevent>
            <el-form-item>
              <el-input placeholder="工号/姓名" v-model="dataGrid.parms.keyword" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                <template #suffix>
                  <el-icon class="el-input__icon pointer" @click="bindTable()">
                    <search />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
          <!-- 搜索区域 END -->
        </el-header>
        <el-main class="mb0 pl0 pr0 pb0">
          <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
            <!-- 冻结列-Left BEGIN -->
            <el-table-column label="序号" type="index" fixed align="center" width="80" />
            <el-table-column label="教师" prop="jsxm" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
            <!-- 冻结列-Left END -->
            <el-table-column label="机构" prop="bmmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
            <el-table-column label="状态" prop="dkzt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                <span v-if="scope.row.dkzt==0">可代课</span>
                <el-tooltip v-if="scope.row.dkzt==1" :content="scope.row.zysm" placement="top">
                  <span style="cursor: pointer;color: rgb(64, 158, 255);">已占用</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <!-- 冻结列-Right BEGIN -->
            <el-table-column label="操作" width="90" fixed="right" align="center">
              <template #default="scope">
                <el-button v-if="scope.row.dkzt==0" type="danger" @click="savestudent(currentRow=scope.row)">选择</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
        </el-main>
      </el-container>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer-but">
            <el-button type="info" @click="closeWindow('openDanTiao', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
    <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
  </div>
</template>
<script setup>
import { ref, defineProps, watch, defineEmits } from 'vue'
import { closeWindow, actionPost } from '@/api/common'
import { warningPrompt, successPrompt } from '@/utils/promptInfo.js'
import detail from '@/components/jiaozhigong/detail'
const props = defineProps({
  openDanTiao: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDanTiao', 'ReturnData'])
const paginationObj = ref()
const row = ref()
const openDetail = ref(false)
const currentRow = ref()

const savestudent = () => {
  emits('ReturnData', currentRow.value)
  closeWindow('openDanTiao', emits, false)
}

// 列表
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'dkzt', order: 'ascending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async () => {
  const o = {
    url: '/api/v2/jiaowu/daikejilu/daikejiaoshi',
    data: dataGrid.value.parms
  }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      dataGrid.value.data = res.data
    } else {
      warningPrompt(res.message)
    }
  })
}
watch(
  () => props.openDanTiao,
  () => {
    if (props.openDanTiao) {
      dataGrid.value.parms = props.row
      bindTable()
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
</style>
